module.exports = __webpack_public_path__ + "img/reports.5fbb543b.svg";